module.exports = __webpack_public_path__ + "static/img/b304.9879adb8.png";